import { CgCloseO } from 'react-icons/cg'
import { ReactComponent as PictoSurfaceSol } from 'assets/default/svg/picto_surface_sol.svg'
import moment from 'moment'
import InformationList from 'components/InformationList'
import { useAppDispatch, useAppSelector } from 'redux/hooks'
import { toggleDetail } from 'redux/features/parcelle/slice'
import { makeSelectSelectedParcelleMoreInformation } from 'redux/features/parcelle/selectors'
import Parcelle from 'entity/Parcelle'
import HistoriqueTable from 'components/Parcelle/Details/HistoriqueTable'
import { Button } from 'react-bootstrap'
import style from './Detail.module.scss'

const Detail = (): JSX.Element | null => {
  moment.locale('fr')

  const parcelle: Parcelle | null = useAppSelector(
    makeSelectSelectedParcelleMoreInformation
  )
  const dispatch = useAppDispatch()

  if (parcelle === null) {
    return null
  }

  const closeDetail = () => {
    dispatch(toggleDetail(parcelle.uid))
  }

  return (
    <div className={style.detail}>
      <Button variant="none" className={style.cross} onClick={closeDetail}>
        <CgCloseO />
      </Button>
      <div className={style.header}>
        <h2>{parcelle.address}</h2>
      </div>
      <div className={style.content}>
        <InformationList parcelle={parcelle} />
        <div className={style.containerBatiCorrespondant}>
          <h3>Bâtis correspondants</h3>
          <div className={style.batiCorrespondantList}>
            {parcelle.batiList.map((area, index) => (
              <div className={style.batiCorrespondant} key={`${area}${index}`}>
                <PictoSurfaceSol />
                <span className={style.title}>Surface au sol {index + 1}</span>
                <span className={style.value}>{Math.floor(area)} m²</span>
              </div>
            ))}
          </div>
        </div>
        {parcelle.historique.length > 0 && (
          <div>
            <h3>Ventes correspondantes</h3>
            <HistoriqueTable historiqueList={parcelle.historique} />
          </div>
        )}
      </div>
    </div>
  )
}

export default Detail
